type FilesEnv = Record<string, string | undefined>;

/**
 * Explicit property reads (not a bare `import.meta.env`) so Vite inlines them
 * and the Jest transform can map them.
 */
function currentEnv(): FilesEnv {
  return {
    VITE_FEATURE_FILES: import.meta.env.VITE_FEATURE_FILES,
    VITE_TYPO3_BASE_URL: import.meta.env.VITE_TYPO3_BASE_URL,
  };
}

/** #93: Files is on only where the proxy has the files.* commands (local dev, e2e). */
export function isFilesEnabled(env: FilesEnv = currentEnv()): boolean {
  return env.VITE_FEATURE_FILES === 'true' && Boolean(env.VITE_TYPO3_BASE_URL);
}
